export default "__VITE_ASSET__jvbsCjBY__"